import urlValidator from './url-validator'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

const errorCode = 'dashboards.embeddedContent.httpsRequired'

/**
 * Validator that ensures the URL is valid and https
 */
function httpsValidator (value) {
	if (_.isEmpty(value)) {
		return
	}

	let result = urlValidator(value)

	if (!_.isNil(result)) {
		// Not a valid URL of any protocol, so reject it
		return i18n.get(errorCode)
	}

	if (value.indexOf('https://') !== 0) {
		// Valid URL but not https, so reject it
		return i18n.get(errorCode)
	}
}

export default httpsValidator

httpsValidator.__filename__ = 'components/validators/https-validator.js'
